import { useClientTranslation } from "@/modules/App/components/i18n/i18n.client"
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogIcon,
  DialogTitle,
  DialogTrigger,
} from "@dalmatech/ui"
import { Trash2 } from "lucide-react"
import Image from "next/image"
import type { ReactNode } from "react"

type DeletePetDialogProps = {
  onClick: () => void
  title: string
  trigger?: ReactNode
}

export function DeletePetDialog({ onClick, title, trigger }: DeletePetDialogProps) {
  const { t } = useClientTranslation("tribe-page")

  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger ?? (
          <Button type="button" variant="ghost" size="xs" shape="icon">
            <Trash2 className="w-5 stroke-2" />
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="w-[36.750rem]">
        <DialogIcon>
          <Image
            src="/img/illus/interrogation-point.svg"
            alt="Help icon"
            width={128}
            height={128}
            draggable={false}
          />
        </DialogIcon>
        <DialogTitle>{title}</DialogTitle>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="ghost" className=" bg-neutral-100 text-neutral-700" size="lg">
              {t("delete-pet-modal.cancel")}
            </Button>
          </DialogClose>
          <Button
            size="lg"
            onClick={onClick}
            variant="primary"
          >
            {t("delete-pet-modal.delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
